<form [formGroup]="form">
  <vs-form-field [config]="{ label: 'Name on account' }" appearance="vertical" class="mb-4">
    <input
      #nameInput
      vsInput
      [required]="true"
      type="text"
      placeholder="Full name on account"
      formControlName="nameOnAccount"
      (blur)="touched$.next()"
      (change)="nameInput.setCustomValidity(form.controls.nameOnAccount.valid ? '' : 'invalid')"
    />
    <p
      *ngIf="form.controls.nameOnAccount.invalid && form.controls.nameOnAccount.touched"
      slot="hint"
      class="text-danger"
    >
      Required - Please provide the account holder's name
    </p>
  </vs-form-field>

  <vs-form-field [config]="{ label: 'Bank name' }" appearance="vertical" class="mb-4">
    <input
      #bankNameInput
      vsInput
      [required]="true"
      type="text"
      placeholder="e.g. Chase Bank"
      formControlName="bankName"
      (blur)="touched$.next()"
      (change)="bankNameInput.setCustomValidity(form.controls.bankName.valid ? '' : 'invalid')"
    />
    <p *ngIf="form.controls.bankName.invalid && form.controls.bankName.touched" slot="hint" class="text-danger">
      Required - Please provide your bank name
    </p>
  </vs-form-field>

  <vs-form-field [config]="{ label: 'Account type' }" appearance="vertical" class="mb-4">
    <select vsInput formControlName="accountType" (blur)="touched$.next()">
      <option *ngFor="let type of accountTypes" [value]="type.value">{{ type.label }}</option>
    </select>
  </vs-form-field>

  <vs-form-field [config]="{ label: 'Routing number' }" appearance="vertical" class="mb-4">
    <input
      #routingInput
      vsInput
      [required]="true"
      type="text"
      mask="000000000"
      placeholder="9-digit routing number"
      formControlName="routingNumber"
      (blur)="touched$.next()"
      (change)="routingInput.setCustomValidity(form.controls.routingNumber.valid ? '' : 'invalid')"
    />
    <p
      *ngIf="form.controls.routingNumber.invalid && form.controls.routingNumber.touched"
      slot="hint"
      class="text-danger"
    >
      Please enter a valid 9-digit routing number
    </p>
  </vs-form-field>

  <vs-form-field [config]="{ label: 'Account number' }" appearance="vertical" class="mb-4">
    <input
      #accountInput
      vsInput
      [required]="true"
      type="text"
      mask="00000000000000000"
      [validation]="false"
      placeholder="Account number"
      formControlName="accountNumber"
      (blur)="touched$.next()"
      (change)="accountInput.setCustomValidity(form.controls.accountNumber.valid ? '' : 'invalid')"
    />
    <p
      *ngIf="form.controls.accountNumber.invalid && form.controls.accountNumber.touched"
      slot="hint"
      class="text-danger"
    >
      Please enter a valid account number (5-17 digits)
    </p>
  </vs-form-field>

  <vs-form-field [config]="{ label: 'Confirm account number' }" appearance="vertical">
    <input
      #confirmInput
      vsInput
      [required]="true"
      type="text"
      mask="00000000000000000"
      [validation]="false"
      placeholder="Re-enter account number"
      formControlName="confirmAccountNumber"
      (blur)="touched$.next()"
      (change)="confirmInput.setCustomValidity(form.controls.confirmAccountNumber.valid ? '' : 'invalid')"
    />
    <p
      *ngIf="form.controls.confirmAccountNumber.hasError('mismatch') && form.controls.confirmAccountNumber.touched"
      slot="hint"
      class="text-danger"
    >
      Account numbers do not match
    </p>
    <p
      *ngIf="form.controls.confirmAccountNumber.hasError('required') && form.controls.confirmAccountNumber.touched"
      slot="hint"
      class="text-danger"
    >
      Please confirm your account number
    </p>
  </vs-form-field>
</form>
